<template>
  <div class="flex flex-wrap gap-4 lg:flex-nowrap" :class="justify">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  justify: {
    type: String,
    default: 'justify-end',
  },
});
</script>
